import React, { Component } from 'react';
import _ from 'lodash';
import NumberUtils from '../../../../utils/NumberUtils';
import ProjectionDateUtils from '../../../../utils/ProjectionDateUtils';
import { ProjectionGridCommitmentEssentialSpends } from './ProjectionGridCommitmentEssentialSpends';

/**
 * @todo
 * The quality of this component is poor.
 * Future improvement work should be done to refactor/remove this component
 * to increase the overall health of the codebase.
 */
class ProjectionGridPanel extends Component {
  constructor(props) {
    super(props);

    this.isProjectionPeriodAvailable =
      this.isProjectionPeriodAvailable.bind(this);
    this.dateConversion = this.dateConversion.bind(this);
    this._showCurrentBalanceDate = this._showCurrentBalanceDate.bind(this);
    this._showCurrentBalance = this._showCurrentBalance.bind(this);
    this._showCommitmentsAmount = this._showCommitmentsAmount.bind(this);
    this._showThresholdAmount = this._showThresholdAmount.bind(this);
    this._projectedCommitmetsCount = this._projectedCommitmetsCount.bind(this);
    this.nextEarningProjectionPeriod =
      this.nextEarningProjectionPeriod.bind(this);
    this.getContent = this.getContent.bind(this);
    this._warningsFlag = this._warningsFlag.bind(this);
    this._showNextEarningsAmount = this._showNextEarningsAmount.bind(this);
    this.isProjectionPeriodAvailable =
      this.isProjectionPeriodAvailable.bind(this);
    this._essentialSpendingsFlag = this._essentialSpendingsFlag.bind(this);
    this.getNextEarnings = this.getNextEarnings.bind(this);
    this.getBack = this.getBack.bind(this);
    this.clickedTakeACloser = this.clickedTakeACloser.bind(this);
    this._getNextEarningContent = this._getNextEarningContent.bind(this);
    this.getHeader = this.getHeader.bind(this);
    this.getTitleHeading = this.getTitleHeading.bind(this);

    this.state = {
      projectionCommEssenFlag: true,
      index: 0,
    };
  }

  isProjectionPeriodAvailable() {
    return (
      this.props.projectionSummary !== undefined &&
      this.props.projectionSummary.projection_periods !== undefined
    );
  }

  dateConversion(value) {
    if (value !== '') {
      const monthName = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      const fullDate = new Date(value);
      const day = fullDate.getDate();
      const month = fullDate.getMonth();
      const year = fullDate.getFullYear();
      const dateStr = `${`0${day}`.slice(-2)} ${monthName[month].substr(
        0,
        3
      )} ${year.toString().substr(2, 4)}`;
      return <span>{dateStr}</span>;
    }
  }

  _showCurrentBalanceDate() {
    let currentBalanceDate;
    if (this.isProjectionPeriodAvailable()) {
      if (this.props.projectionSummary.projection_periods !== undefined) {
        currentBalanceDate = this.dateConversion(
          this.props.projectionSummary.projection_periods[0].period.from.date
        );
      }
    }
    return currentBalanceDate;
  }

  _showCurrentBalance() {
    if (this.isProjectionPeriodAvailable()) {
      return NumberUtils.appendCurrency(
        '{}',
        this.props.projectionSummary.projection_periods[0].period.from
          .available_balance.value
      );
    }
  }

  _showCommitmentsAmount() {
    let cAmount;
    if (this.isProjectionPeriodAvailable()) {
      cAmount = (
        <strong>
          {' '}
          {NumberUtils.appendCurrency(
            '{}',
            this.props.projectionSummary.projection_periods[0]
              .projected_transactions.total_amount.value
          )}
        </strong>
      );
      return cAmount;
    }
  }

  _showThresholdAmount() {
    if (this.isProjectionPeriodAvailable()) {
      const amount = this.props.projectionSummary.thresholds.lower.amount.value;
      return <strong>{NumberUtils.appendCurrency('{}', amount)}</strong>;
    }
  }

  _projectedCommitmetsCount() {
    let cCount;
    if (this.isProjectionPeriodAvailable()) {
      cCount =
        this.props.projectionSummary.projection_periods[0]
          .projected_transactions.transactions.length;
      return `You have ${cCount} projected commitments`;
    }
  }

  nextEarningProjectionPeriod() {
    if (this.props.projectionSummary !== undefined) {
      let i;
      for (
        i = 1;
        i <= this.props.projectionSummary.projection_periods.length;
        i++
      ) {
        if (this.props.projectionSummary.projection_periods[i] !== undefined) {
          if (
            this.props.projectionSummary.projection_periods[i].earnings !==
            undefined
          ) {
            if (
              this.props.projectionSummary.projection_periods[i].earnings
                .length > 0
            ) {
              return true;
            } else {
              return false;
            }
          }
        }
      }
      return false;
    }
  }

  getContent() {
    let earningDiv;
    let projectedBalanceString = 'Your projected balance';
    let earningsString = '';
    if (this.props.projectionSummary !== undefined) {
      earningsString = this.props.content.projectedBalanceInNext31Days;
      if (this.nextEarningProjectionPeriod()) {
        earningsString =
          this.props.content
            .projectionPredictionYourProjectedBalanceBeforeNextEarning;
      }
    }
    if (this.props.projectionSummary !== undefined) {
      if (this.props.projectionSummary.projection_periods.length > 0) {
        if (
          this.props.projectionSummary.projection_periods[0].earnings.length > 0
        ) {
          earningDiv =
            this.props.projectionSummary.projection_periods[0].earnings.map(
              (earningsData, index) => {
                return (
                  <article
                    key={`ProjectionGridPanel_getContent_earningsData_${index}`}
                  >
                    <aside>
                      <section>
                        <b>{this.dateConversion(earningsData.when)}</b>{' '}
                        {this.props.content.projectionPredictionEarningString}
                      </section>
                      <section>
                        <strong>
                          {NumberUtils.appendCurrency(
                            '{}',
                            earningsData.amount.value
                          )}
                        </strong>
                      </section>
                    </aside>
                  </article>
                );
              }
            );
        }
      }
    }
    let projectedBalanceCss = 'projection-grid-body';
    if (this._warningsFlag()) {
      projectedBalanceCss = 'projection-grid-body danger';
    }
    let tagTotalmount;
    if (this.isProjectionPeriodAvailable()) {
      tagTotalmount = NumberUtils.appendCurrency(
        '{}',
        this.props.projectionSummary.projection_periods[0].essential_spend_info
          .total_amount.value
      );
    }
    return (
      <div className="projection-scrollable">
        <div className={projectedBalanceCss}>
          <h4>Before next earning</h4>
          <article>
            <aside>
              <section>
                <strong>{this._showCurrentBalanceDate()}&nbsp;&nbsp;</strong>{' '}
                Current Balance
              </section>
              <section>
                <strong>{this._showCurrentBalance()}</strong>
              </section>
            </aside>
          </article>

          {earningDiv}

          <article>
            <aside>
              <section>{this._projectedCommitmetsCount()}</section>
              <section>
                <strong>{this._showCommitmentsAmount()}</strong>
              </section>
            </aside>
          </article>

          {this._essentialSpendingsFlag() ? (
            <article>
              <aside>
                <section>Essential spend</section>
                <section>
                  <strong>{tagTotalmount}</strong>
                </section>
              </aside>
            </article>
          ) : (
            ''
          )}
          {this._warningsFlag() ? (
            <div className="">
              <article>
                <aside>
                  <section>
                    <strong>Your threshold</strong>
                  </section>
                  <section>{this._showThresholdAmount()}</section>
                </aside>
              </article>
              <article className="projected-balace">
                <aside>
                  <section className="projected-balace">
                    <strong>{projectedBalanceString}</strong>
                  </section>
                  <section>
                    <strong>{this._showNextEarningsAmount()}</strong>
                  </section>
                </aside>
              </article>
            </div>
          ) : (
            <div className="">
              <article className="projected-balace">
                <aside>
                  <section>
                    <strong>{projectedBalanceString}</strong>
                  </section>
                  <section>
                    <strong>{this._showNextEarningsAmount()}</strong>
                  </section>
                </aside>
              </article>
              <article>
                <aside>
                  <section>
                    <strong>Your threshold</strong>
                  </section>
                  <section>{this._showThresholdAmount()}</section>
                </aside>
              </article>
            </div>
          )}
          <button id="0" onClick={this.clickedTakeACloser}>
            <strong>Take a closer look</strong>
          </button>
        </div>
        {this.getNextEarnings()}
      </div>
    );
  }

  _warningsFlag() {
    if (this.isProjectionPeriodAvailable()) {
      return (
        this.props.projectionSummary.projection_periods[0].warning_days.length >
        0
      );
    }
  }

  _showNextEarningsAmount() {
    if (this.isProjectionPeriodAvailable()) {
      return (
        <span>
          {NumberUtils.appendCurrency(
            '{}',
            this.props.projectionSummary.projection_periods[0].period.to
              .available_balance.value
          )}
        </span>
      );
    }
  }

  isProjectionPeriodAvailable() {
    return (
      this.props.projectionSummary !== undefined &&
      this.props.projectionSummary.projection_periods !== undefined
    );
  }

  _essentialSpendingsFlag() {
    if (this.props.projectionSummary !== undefined) {
      if (
        this.props.projectionSummary.projection_periods[0].essential_spend_info
          .total_amount.value === 0
      ) {
        return false;
      } else {
        return true;
      }
    }
  }

  getNextEarnings() {
    const totalComponent = [];
    let newComponent;
    let newEarningsDiv;
    let lastEarnings;
    let beforeNextEarnings = 'Before Next Earning';
    if (this.isProjectionPeriodAvailable()) {
      if (this.props.projectionSummary.projection_periods.length >= 1) {
        let i;
        for (
          i = 1;
          i < this.props.projectionSummary.projection_periods.length;
          i++
        ) {
          const commitmentCount =
            this.props.projectionSummary.projection_periods[i]
              .projected_transactions.transactions.length;
          let commitmentString = `You have ${commitmentCount} projected commitments`;
          let essentialSpendAmount = NumberUtils.appendCurrency(
            '{}',
            this.props.projectionSummary.projection_periods[i]
              .essential_spend_info.total_amount.value
          );
          let commitmentTotalAmount = NumberUtils.appendCurrency(
            '{}',
            this.props.projectionSummary.projection_periods[i]
              .projected_transactions.total_amount.value
          );
          newEarningsDiv = this.props.projectionSummary.projection_periods[
            i
          ].earnings.map((earningsData, index) => {
            return (
              <article
                key={`ProjectionGridPanel_getNextEarnings_earningsData_${index}`}
              >
                <aside>
                  <section>
                    <strong>{this.dateConversion(earningsData.when)}</strong>{' '}
                    {this.props.content.projectionPredictionEarningString}
                  </section>
                  <section>
                    <strong>
                      {NumberUtils.appendCurrency(
                        '{}',
                        earningsData.amount.value
                      )}
                    </strong>
                  </section>
                </aside>
              </article>
            );
          });
          if (
            i ===
            this.props.projectionSummary.projection_periods.length - 1
          ) {
            beforeNextEarnings = 'Within the next 31 days';
            lastEarnings = (
              <article className="projected-balace">
                <aside>
                  <section>
                    <strong>Your projected balance</strong>
                  </section>
                  <section>
                    <strong>
                      {NumberUtils.appendCurrency(
                        '{}',
                        this.props.projectionSummary.projection_periods[i]
                          .period.to.available_balance.value
                      )}
                    </strong>
                  </section>
                </aside>
              </article>
            );
          }

          newComponent = (
            <div className="projection-grid-body">
              <h4>{beforeNextEarnings}</h4>
              {newEarningsDiv}

              <article>
                <aside>
                  <section>{commitmentString}</section>
                  <section>
                    <strong>{commitmentTotalAmount}</strong>
                  </section>
                </aside>
              </article>
              <article>
                <aside>
                  <section>Essential spend</section>
                  <section>
                    <strong>{essentialSpendAmount}</strong>
                  </section>
                </aside>
              </article>
              {lastEarnings}
              <button id={i} onClick={this.clickedTakeACloser}>
                <strong>Take a closer look</strong>
              </button>
            </div>
          );
          totalComponent.push(newComponent);
        }
      }
    }
    return totalComponent;
  }

  getBack() {
    this.setState({
      projectionCommEssenFlag: true,
    });
  }

  clickedTakeACloser(e) {
    this.setState({
      projectionCommEssenFlag: false,
      index: e.currentTarget.id,
    });
  }

  _getNextEarningContent() {
    let amount;
    let earningData;
    let earningDate;
    let whenDate;
    let amountFormat;
    let amountArr;
    let dateOrd;
    let earningHeader1 =
      this.props.content.projectionsExpandedItemViewYourNextEarningHeading;
    const earningFooter1 =
      this.props.content.projectionsExpandedItemViewYouCanReviewThisFootNote;
    let warningDaysFlag = false;
    let tomorrowsFlagForEarnings = false;
    if (this.props.projectionSummary !== undefined) {
      if (this.props.projectionSummary.projection_periods[0] !== undefined) {
        if (
          this.props.projectionSummary.projection_periods[0].warning_days
            .length > 0
        ) {
          warningDaysFlag = true;
        }
        if (
          this.props.projectionSummary.projection_periods[0].earnings.length > 0
        ) {
          earningHeader1 =
            this.props.content
              .projectionsExpandedItemViewTomorrowsEarningHeading;
          tomorrowsFlagForEarnings = true;
        }
      }
    }
    const earningsFirstPeriodAmountArray = [];
    let earningsFirstPeriodTotalAmount = 0;
    let i;
    if (this.props.projectionSummary !== undefined) {
      if (this.props.projectionSummary.projection_periods !== undefined) {
        if (
          this.props.projectionSummary.projection_periods[0].earnings.length > 0
        ) {
          this.props.projectionSummary.projection_periods[0].earnings.map(
            (earningsAmount) => {
              earningsFirstPeriodAmountArray.push(earningsAmount.amount.value);
              earningsFirstPeriodTotalAmount =
                earningsFirstPeriodAmountArray.reduce((a, b) => {
                  return a + b;
                }, 0);
              return earningsFirstPeriodTotalAmount;
            }
          );
        }
      }
    }
    if (this.props.projectionSummary !== undefined) {
      if (this.props.projectionSummary.projection_periods[1] !== undefined) {
        if (
          this.props.projectionSummary.projection_periods[1].earnings.length > 0
        ) {
          amountFormat =
            this.props.projectionSummary.projection_periods[1].earnings[0]
              .amount.value;
          amountArr = _.split(
            NumberUtils.appendCurrency('{}', earningsFirstPeriodTotalAmount),
            '.'
          );
          if (tomorrowsFlagForEarnings === true && warningDaysFlag === true) {
            dateOrd =
              this.props.content
                .projectionsExpandedItemViewTomorrowsEarningRunningLowSubHeading;
            amountArr = _.split(
              NumberUtils.appendCurrency('{}', earningsFirstPeriodTotalAmount),
              '.'
            );
          } else if (
            tomorrowsFlagForEarnings === true &&
            warningDaysFlag === false
          ) {
            dateOrd = ' ';
            amountArr = _.split(
              NumberUtils.appendCurrency('{}', earningsFirstPeriodTotalAmount),
              '.'
            );
          } else if (
            tomorrowsFlagForEarnings === false &&
            warningDaysFlag === false
          ) {
            amountArr = _.split(
              NumberUtils.appendCurrency('{}', amountFormat),
              '.'
            );
            dateOrd =
              this.props.content.projectionsExpandedItemViewProjectedIn +
              ProjectionDateUtils.getDaysCount(
                this.props.projectionSummary.projection_periods[1].earnings[0]
                  .when
              );
          } else if (
            tomorrowsFlagForEarnings === false &&
            warningDaysFlag === true
          ) {
            dateOrd =
              this.props.content.projectionsExpandedItemViewProjectedIn +
              ProjectionDateUtils.getDaysCount(
                this.props.projectionSummary.projection_periods[1].earnings[0]
                  .when
              );
            amountArr = _.split(
              NumberUtils.appendCurrency('{}', amountFormat),
              '.'
            );
          }
        }
      }
    }
    return (
      <div>
        <div>{earningHeader1}</div>
        <div>
          {amountArr[0]}.<div>{amountArr[1]}</div>
        </div>
      </div>
    );
  }

  getHeader() {
    return (
      <div className="row no-gutters">
        <div className="col-xs-3">
          <button className="page-back white" onClick={this.props.clickBack}>
            <span className="icon icon-page-back" />
            {this.props.content.back}
          </button>
        </div>
        <div className="col-xs-6 text-center">
          <h5>Projections</h5>
        </div>
        <div className="col-xs-3 text-right">
          {' '}
          <button
            className="icon icon-settings"
            onClick={this.props.goToProjectionSettingsPage}
          />
        </div>
      </div>
    );
  }

  getTitleHeading() {
    let headerMessage;
    let warningDays;
    let tomorrowsEarnings;
    let overAllAmount;
    let currentAmount;
    let essentialAmount;
    let amount;
    let lAmount;
    let amountArr;
    let amount1;
    let amount2;
    let warningDate;
    if (this.props.projectionSummary !== undefined) {
      warningDays =
        this.props.projectionSummary.projection_periods[0].warning_days.length;
      if (
        this.props.projectionSummary.projection_periods[0].earnings.length > 0
      ) {
        tomorrowsEarnings =
          this.props.projectionSummary.projection_periods[0].earnings[0].amount
            .value;
      } else {
        tomorrowsEarnings = 0;
      }
      currentAmount =
        this.props.projectionSummary.projection_periods[0].period.from
          .available_balance.value;
      essentialAmount =
        this.props.projectionSummary.projection_periods[0].essential_spend_info
          .total_amount.value;
      amount =
        this.props.projectionSummary.projection_periods[0]
          .projected_transactions.total_amount.value;
      lAmount = this.props.projectionSummary.thresholds.lower.amount.value;
      overAllAmount =
        currentAmount +
        essentialAmount +
        amount +
        tomorrowsEarnings +
        lAmount * -1;
      amountArr = _.split(NumberUtils.appendCurrency('{}', overAllAmount), '.');
      amount1 = amountArr[0];
      amount2 = amountArr[1];
      if (warningDays === 0) {
        return (headerMessage = (
          <span>
            {'B predicts you are good to go. You should have '}
            <span>
              <strong>{amount1}.</strong>
            </span>
            <span>
              <strong>{amount2}</strong>
            </span>
          </span>
        ));
      } else {
        warningDate = ProjectionDateUtils.dateConversion(
          this.props.projectionSummary.projection_periods[0].warning_days[0]
        );
        return (headerMessage = (
          <span>
            <span>Looks like you'll go below your</span>
            <br />
            <span>
              {' '}
              low balance limit of{' '}
              <strong>
                {NumberUtils.appendCurrency(
                  '{}',
                  this.props.projectionSummary.thresholds.lower.amount.value
                )}
              </strong>{' '}
              on <strong>{warningDate}</strong>
            </span>
          </span>
        ));
      }
    }
  }

  render() {
    return this.state.projectionCommEssenFlag ? (
      <div className="projection-mobile">
        <div className="projection-grid-heading">
          {this.getHeader()}
          <p className="grid-title text-center">{this.getTitleHeading()}</p>
        </div>
        <div className="projection-grid">{this.getContent()}</div>
      </div>
    ) : (
      <ProjectionGridCommitmentEssentialSpends
        getBack={this.getBack}
        goToProjectionSettingsPage={this.props.goToProjectionSettingsPage}
        projectionSummary={this.props.projectionSummary}
        index={parseInt(this.state.index)}
      />
    );
  }
}

export { ProjectionGridPanel };
